import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../colors';

export const ReservationListPageStyled = {
  Container: styled(Grid)<any>`
    width: 100%;
    background: ${Colors.PrimaryBackground};
    padding-left: 42px;
    padding-right: 42px;
  `,
  ListContainer: styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: whitesmoke;
    border-radius: 4px;
    border-collapse: separate;
  `,
  TitlePage: styled.p`
    margin-top: 35px;
    color: ${Colors.White};
    font-family: EncodeSans-Medium;
    font-size: 16px;
  `,
  SubtitlePage: styled.p`
    margin-top: 5px;
    color: ${Colors.White};
    font-family: EncodeSans-Medium;
    font-size: 12px;
    margin-bottom: 24px;
  `,
  ContainerButtonThingsboard: styled.div`
    background-color: red;
    cursor: pointer;
  `,
};
